import MagstimTableTreatmentTemplateBase from './MagstimTableTreatmentTemplateBase';

import './MagstimTable.css'
import './MagstimTableTreatmentTemplateMultiSelect.css'

class MagstimTableTreatmentTemplateMultiSelect extends MagstimTableTreatmentTemplateBase {

	init = (data) => {
		// console.log('MagstimTableTreatmentTemplateMultiSelect.init');
		this.initTable(this.configTableTreatmentTemplateMultiSelect(data), true);
	}

	configTableTreatmentTemplateMultiSelect(data) {
		return {
			multiselect: true,
			select: {
				checked: { icon: 'fas fa-check-square', color: '#00AEEF' },
				unchecked: { icon: 'fas fa-square', color: '#C9DEFF' },
			},
			columns: this.columnsTableTreatmentTemplateSelect(),
			data: data
		};
	}
}

export default MagstimTableTreatmentTemplateMultiSelect;